import React from 'react'
import SalesReport from '../Components/Reports/SalesReport'

function SalesReportPage() {
  return (
    <>
    <SalesReport/>
    </>
  )
}

export default SalesReportPage